const tradingContest = {
  state: {
    starTeamCycle: {}, // 所有活动周期
    individualCycle: {}, // 个人
    simulatedCycle: {}, // 模拟盘活动周期
    contractCycle: {}, // 合约活动周期
    spotCycle: {}, // 现货活动周期
    activityUserInfo: {}, // 用户信息
    appToken: '',
    activityId: "", // 活动id
  },
  mutations: {
    set_simulatedCycle(state, value) {
      if (value != {}) {
        state.simulatedCycle = { ...value };
      }
    },
    set_contractCycle(state, value) {
      state.contractCycle = { ...value };
    },
    set_spotCycle(state, value) {
      state.spotCycle = { ...value };
    },
    set_individualCycle(state, value) {
      state.individualCycle = { ...value };
    },
    set_activityUserInfo(state, value) {
      state.activityUserInfo = { ...value }
    },
    set_starTeamCycle(state, value) {
      state.starTeamCycle = {...value}
    },
    set_AppToken(state, token) {
      state.appToken = token
    },
    set_ActivityId(state, id) {
      state.activityId = id || 0
    }
  },
};

export default tradingContest;



// WEBPACK FOOTER //
// ./src/store/tradingContest/index.js